import React from "react";
import {PROFILE_PAGES} from "./constants";
import ErrorFeedbackBar from "../global/ErrorFeedbackBar";
import FeedbackBar from "../feedbackBar/FeedbackBar";
import {statusSelector} from "../../redux/selectors/global";
import {userInfoSelector} from "../../redux/selectors/auth";
import withShipment from "../../withShipment";
import AllLocationPlan from "./AllLocationPlan";
import {availableCompaniesSelector} from "../../redux/selectors/account";
import {listAvailableCompanies} from "../../redux/actions/settings";
import LocationDetailView from './LocationDetailView';
import { fetchLocationDetail } from '../../redux/actions/userManagement';
import { locationDetailSelector } from '../../redux/selectors/userManagement';
import CustomToolbar from "../global/CustomToolbar";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import Paper from "@material-ui/core/Paper";


class UserProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: PROFILE_PAGES.LOCATION_PLAN,
      feedbackBarOpen: false,
      error: false,
      feedbackStatus: '',
      feedbackMessage: '',
      selectedLocation: null,

    }
  }

  componentDidMount() {
    this.props.listAvailableCompanies()
  }


  componentDidUpdate(prevProps, prevState) {
    if (this.props.status.statusText && prevProps.status.statusText !== this.props.status.statusText) {
      this.openFeedbackBar(this.props.status.statusText, 'error');
    }
  }

 handleBack = () => {
        this.setState({ selectedLocation: null }, () => {
            this.setCurrentPage(PROFILE_PAGES.LOCATION_PLAN, {})
        })
    }

    handleOpenLocation = (location) => {
        this.setState({ selectedLocation: location }, () => {
        this.props.fetchLocationDetail({locationId: location.companyId})
            this.setCurrentPage(PROFILE_PAGES.LOCATION_DETAIL_VIEW, {})
        })
    }

  renderAllLocation = () => {
    return (
      <AllLocationPlan
          user={this.props.user}
          setCurrentPage={this.setCurrentPage}
          openFeedbackBar={this.openFeedbackBar}
          availableCompanies={this.props.availableCompanies}
          handleOpenLocation={this.handleOpenLocation}

      />
    )
  }

  renderDetailView = () => {
    return (
        <LocationDetailView
          user={this.props.user}
          setCurrentPage={this.setCurrentPage}
          openFeedbackBar={this.openFeedbackBar}
          location={this.state.selectedLocation}
          handleBack={this.handleBack}
          locationDetail={this.props.locationDetail}

      />

    )
  }


  setCurrentPage = (newPage) => {
    this.setState({
      currentPage: newPage
    })
  }



  handleDeleteRow = (deleteId) => {
    this.props.deleteManageBonus({manageBonusId: deleteId})
  }


  displayCurrentPage = () => {
    switch (this.state.currentPage) {
      case PROFILE_PAGES.LOCATION_PLAN:
        return this.renderAllLocation()
      case PROFILE_PAGES.LOCATION_DETAIL_VIEW:
        return this.renderDetailView()
      default:
        return <div>We encountered an error. Please refresh the page.</div>
    }
  }


  openFeedbackBar = (status, message) => {
    this.setState({ feedbackStatus: status, feedbackMessage: message, feedbackBarOpen: true });
  }

  closeFeedbackBar = () => {
    this.setState({ feedbackBarOpen: false, feedbackStatus: '', feedbackMessage: '' }, () => {
      this.props.clearStatus();
    });
  }


  render() {


    const isDetail = this.state.currentPage === PROFILE_PAGES.LOCATION_DETAIL_VIEW;
    const title = 'My Account';

    const headerButtons = isDetail
      ? [{ icon: <KeyboardBackspaceIcon />, handler: this.handleBack, title: 'Back' }]
      : [];

    return (
        <React.Fragment>
          <Paper className="paper">
            <ErrorFeedbackBar/>
            <FeedbackBar
                open={this.state.feedbackBarOpen}
                handleClose={this.closeFeedbackBar}
                severity={this.state.feedbackStatus}
                message={this.state.feedbackMessage}
            />
            <CustomToolbar
              title={title}
              headerButtons={headerButtons}
            />
            {this.displayCurrentPage()}
          </Paper>
        </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  status: statusSelector(state),
  user: userInfoSelector(state),
  availableCompanies: availableCompaniesSelector(state),
  locationDetail: locationDetailSelector(state)
})


const actionCreators = {
  listAvailableCompanies,
  fetchLocationDetail
}

export default withShipment({
  actionCreators,
  mapStateToProps
}, UserProfile);